var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('password-guide',{staticClass:"student-password-reminder-complete",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("パスワード再設定")]},proxy:true},{key:"description",fn:function(){return [_c('div',[_vm._v("登録メールアドレスに再設定メールを送信しました。")]),_c('div',[_vm._v("手順に沿ってパスワードを再設定してください。")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }